import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/homeSlides';

export default function HeroCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goTo = (index: number) => setActive((index + heroSlides.length) % heroSlides.length);

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden rounded-lg bg-foreground-950" aria-label="焦点内容轮播">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${index === active ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
          <img src={slide.image} alt={`${slide.title} 焦点图`} title={`${slide.title} 热门推荐`} className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/45 to-foreground-950/20"></div>
          <div className="absolute inset-0 flex items-end">
            <div className="w-full max-w-page mx-auto px-4 md:px-6 pb-10 md:pb-14">
              <div className="max-w-2xl animate-fade-up">
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 text-xs font-label font-medium">
                  <i className="ri-fire-line"></i>
                  {slide.tag}
                </span>
                <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">{slide.title}</h2>
                <p className="mt-3 text-sm md:text-base text-background-100/90 leading-relaxed line-clamp-2">{slide.intro}</p>
                <Link
                  to={slide.link}
                  className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-50 text-foreground-950 text-sm font-label font-medium hover:bg-accent-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  查看详情
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}

      <button
        type="button"
        aria-label="上一张"
        onClick={() => goTo(active - 1)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 rounded-full bg-foreground-950/40 text-background-50 flex items-center justify-center hover:bg-accent-500 transition-colors cursor-pointer backdrop-blur-sm"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => goTo(active + 1)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 rounded-full bg-foreground-950/40 text-background-50 flex items-center justify-center hover:bg-accent-500 transition-colors cursor-pointer backdrop-blur-sm"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-4 md:bottom-6 right-4 md:right-6 flex items-center gap-2">
        {heroSlides.map((slide, index) => (
          <button
            key={slide.id}
            type="button"
            aria-label={`切换到第 ${index + 1} 张`}
            onClick={() => goTo(index)}
            className={`h-2 rounded-full transition-all cursor-pointer ${index === active ? 'w-7 bg-accent-500' : 'w-2 bg-background-50/60'}`}
          ></button>
        ))}
      </div>
    </section>
  );
}